
export const breadcrumb = [
    { path: '/', parent: 'Dashboard', label: 'Dashboard' },
    { path: '/formlayout', parent: 'UI Kit', label: 'Form Layout' },
    { path: '/input', parent: 'UI Kit', label: 'Input' },
    { path: '/floatlabel', parent: 'UI Kit', label: 'Float Label' },
    { path: '/invalidstate', parent: 'UI Kit', label: 'Invalid State' },
    { path: '/button', parent: 'UI Kit', label: 'Button' },
    { path: '/table', parent: 'UI Kit', label: 'Table' },
    { path: '/list', parent: 'UI Kit', label: 'List' },
    { path: '/tree', parent: 'UI Kit', label: 'Tree' },
    { path: '/panel', parent: 'UI Kit', label: 'Panel' },
    { path: '/overlay', parent: 'UI Kit', label: 'Overlay' },
    { path: '/media', parent: 'UI Kit', label: 'Media' },
    { path: '/menu', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/seat', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/payment', parent: 'UI Kit', label: 'Menu' },
    { path: '/menu/confirmation', parent: 'UI Kit', label: 'Menu' },
    { path: '/messages', parent: 'UI Kit', label: 'Messages' },
    { path: '/file', parent: 'UI Kit', label: 'File' },
    { path: '/chart', parent: 'UI Kit', label: 'Charts' },
    { path: '/misc', parent: 'UI Kit', label: 'Misc' },
    { path: '/icons', parent: 'Utilities', label: 'Icons' },
    { path: '/blocks', parent: 'PrimeBlocks', label: 'Blocks' },
    { path: '/crud', parent: 'Utilities', label: 'Crud' },
    { path: '/calendar', parent: 'PrimeBlocks', label: 'Calendar' },
    { path: '/timeline', parent: 'Pages', label: 'Timeline' },
    { path: '/invoice', parent: 'Pages', label: 'Invoice' },
    { path: '/invoice2', parent: 'Pages', label: 'Invoice2' },
    { path: '/help', parent: 'Pages', label: 'Help' },
    { path: '/empty', parent: 'Pages', label: 'Empty Page' },
    { path: '/documentation', parent: 'Pages', label: 'Documentation' },

    { path: '/asset', parent: 'Asset', label: 'Asset' },
    { path: '/soft/asset', parent: 'Asset', label: 'Asset' },
    { path: '/vendor', parent: 'Vendor', label: 'Vendor' },
    { path: '/employee', parent: 'Employee', label: 'Employee' },

    { path: '/report', parent: 'Report', label: 'Report' },
    { path: '/report-by-category-vs-company', parent: 'Report', label: 'Report By Category' },
    { path: '/report-by-category-vs-brand', parent: 'Report', label: 'Report Category Vs Brand' },
    { path: '/report-by-department-vs-category', parent: 'Report', label: 'Report Department Vs Category' },
    { path: '/others', parent: 'Others', label: 'Others' },
    { path: '/users', parent: 'Users', label: 'Users' },
    { path: '/change_password', parent: 'Settings', label: 'Change password' },
    { path: '/logout', parent: 'Settings', label: 'Logout' },


];
